import SessionStorage from '../../utils/storage/SessionStorage';
import {STORAGE_KEYS} from '../../utils/constants';

function resetPersonalDataFormStorage() {
  SessionStorage.remove(STORAGE_KEYS.personalFormData);
  SessionStorage.remove(STORAGE_KEYS.personalSignatureFormData);
}

export {resetPersonalDataFormStorage};
